var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from "./component";
var Collapse = /** @class */ (function (_super) {
    __extends(Collapse, _super);
    function Collapse(args) {
        var _a;
        var _this = _super.call(this, args) || this;
        _this.isCollapsed = true;
        _this.toggle = function () {
            if (_this.isCollapsed) {
                _this.componentInstance.show();
                _this.isCollapsed = false;
            }
            else {
                _this.componentInstance.hide();
                _this.isCollapsed = true;
            }
        };
        _this.beforeInitialise = function () {
            var _a, _b, _c;
            _this.componentInstance = new mdb.Collapse(_this.composer.collapseEl, _this.options);
            var originalShow = (_a = _this.events) === null || _a === void 0 ? void 0 : _a.show;
            var originalHide = (_b = _this.events) === null || _b === void 0 ? void 0 : _b.hide;
            _this.events.show = function (event) {
                var _a;
                event.stopPropagation();
                (_a = _this === null || _this === void 0 ? void 0 : _this.chevron) === null || _a === void 0 ? void 0 : _a.classList.add('rotated');
                originalShow === null || originalShow === void 0 ? void 0 : originalShow.call(_this, event);
            };
            _this.events.hide = function (event) {
                var _a;
                event.stopPropagation();
                (_a = _this === null || _this === void 0 ? void 0 : _this.chevron) === null || _a === void 0 ? void 0 : _a.classList.remove('rotated');
                originalHide === null || originalHide === void 0 ? void 0 : originalHide.call(_this, event);
            };
            if (_this.events) {
                Object.keys(_this.events).forEach(function (key) {
                    var _a, _b;
                    (_b = (_a = _this === null || _this === void 0 ? void 0 : _this.collapseEl) === null || _a === void 0 ? void 0 : _a.addEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, "".concat(key, ".mdb.collapse"), _this.events[key]);
                });
            }
            _this.isCollapsed = !((_c = _this.options.toggle) !== null && _c !== void 0 ? _c : true);
            setTimeout(function () {
                var _a;
                (_a = _this === null || _this === void 0 ? void 0 : _this.toggleEl) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
                    console.log('time to toggle');
                    _this.toggle();
                });
            }, 0);
        };
        _this.name = 'collapse';
        _this.toggleEl = args.composer.toggleEl;
        _this.collapseEl = args.composer.collapseEl;
        _this.options = (_a = args === null || args === void 0 ? void 0 : args.options) !== null && _a !== void 0 ? _a : { toggle: true };
        return _this;
    }
    Object.defineProperty(Collapse.prototype, "chevron", {
        get: function () {
            return this.toggleEl.querySelector('.collapse-chevron');
        },
        enumerable: false,
        configurable: true
    });
    return Collapse;
}(Component));
export { Collapse };
